import { subscribe, unsubscribe } from '@wh/message-bus';
import { OB_SESSION_STATE_CHANGED, REQUEST_GOT_LOGIN_STATE_EVENT, SESSION_SYNCHRONIZED_EVENT } from '../../topics';
import { fetchCustUserDataAndNotify, handleOBSessionStateChange } from './handlers';

export const getCookieDomain = (url) => {
  const domainRegEx = /\w*(\.williamhill(?:-)?(\w*)?\.([\w]{2,}))/g;
  const [, domain] = domainRegEx.exec(url) || new Array(2);
  return domain;
};

export default (openbetLoginUrl, config, jurisdiction) => {
  const domain = getCookieDomain(openbetLoginUrl);

  const obSessionSubscription = subscribe({
    topic: OB_SESSION_STATE_CHANGED,
    callback: handleOBSessionStateChange({ jurisdiction, domain, config }),
  });

  const sessionSyncSubscription = subscribe({
    topic: SESSION_SYNCHRONIZED_EVENT,
    callback: fetchCustUserDataAndNotify(openbetLoginUrl),
  });

  const requestGotLoginStateSubscription = subscribe({
    topic: REQUEST_GOT_LOGIN_STATE_EVENT,
    callback: fetchCustUserDataAndNotify(openbetLoginUrl),
  });

  return () => {
    unsubscribe(obSessionSubscription);
    unsubscribe(sessionSyncSubscription);
    unsubscribe(requestGotLoginStateSubscription);
  };
};
